module.exports = __webpack_public_path__ + "static/headshot-e7a1c7c21d50c340283c83926b7c830b.jpg";